function attachCheckboxHandler() {
  setTimeout(() => {
    const giftCheckbox = document.getElementById('gift2-checkbox');
    if (giftCheckbox) {
      console.log('Gift checkbox found:', giftCheckbox);
      giftCheckbox.addEventListener('change', function () {
        console.log('Gift checkbox changed:', this.checked);
        
        const isChecked = this.checked;
        const data = {
          attributes: {
            gift: isChecked ? "Yes" : ""
          }
        };
      console.log('Updating cart with data:', data);
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(response => {
        if (response.ok) {
          return response.json();
        } else {
          console.error('Failed to update cart.');
        }
      }).then(cart => {
        console.log('Cart updated successfully:', cart);
      }).catch(error => {
        console.error('Error updating cart:', error);
      });
      });
      
  } else {
    console.error('Gift checkbox not found on cart page.');
    }
  }, 1000);
};
  
document.addEventListener("DOMContentLoaded", function () {
    attachCheckboxHandler()
  
});
    
// Listen for cart updates
document.addEventListener('theme:loading:end', function () {
  // Call your function here
  console.log("Cart has been updated!");
  attachCheckboxHandler();
});
